import { 
	GET_PROJECT_ASSEMBLIES, 
	GET_PROJECT_ASSEMBLY,
	GET_PROJECT_ASSEMBLY_AND_LAST_WI,
	CREATE_PROJECT_ASSEMBLY,
	UPDATE_PROJECT_ASSEMBLY,
	DESTROY_PROJECT_ASSEMBLY,
} from "./actions"

export function ProjectAssembliesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_ASSEMBLIES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_ASSEMBLY}_FULFILLED`:
		case `${GET_PROJECT_ASSEMBLY_AND_LAST_WI}_FULFILLED`:
		case `${CREATE_PROJECT_ASSEMBLY}_FULFILLED`:
		case `${UPDATE_PROJECT_ASSEMBLY}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_ASSEMBLY}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectAssembliesReducer } from "modules/project/assemblies/reducer"

// project_assemblies:ProjectAssembliesReducer,
